// @flow
type Props = {
  value: string | number,
  currency?: string,
};

const FormattedCurrency = ({ value, currency = "£" }: Props) => {
  const space = currency.length > 1 ? " " : "";
  if (typeof value === "number") {
    return (
      <span>
        {`${currency}${space}${Number(value).toLocaleString("en-GB")}`}
      </span>
    );
  }
  if (typeof value === "string" && !value.startsWith(currency)) {
    return <span>{`${currency}${value}`}</span>;
  }
  return <span>{value}</span>;
};

export { FormattedCurrency };
